import { Modal, Button } from "react-bootstrap";
import React, { useState, useEffect, useHistory } from "react";
import Collapsible from "react-collapsible";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "../Loader";
const phoneRegExp = /^(^\+251|^251|^0)?9\d{8}$/;

const basicSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last Name is required"),
  address: Yup.string().required("Address is required"),
  gender: Yup.string().required("Gender is required"),
  driverScince: Yup.date()
    .nullable()
    .required("Driver Scince  is required")
    .max(new Date(), "Driver since must be earlier than today"),
  documents: Yup.mixed().required("Document is required"),
  driverImage: Yup.mixed().required("Image is required"),
  phoneNumber: Yup.string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required(),
  status: Yup.string().required("Status is required"),
});

const Edit = ({ showModal, hideModal, id, data, getDrivers }) => {
  const history = useNavigate();
  let [loading, setLoading] = useState(false);
  let [errorMsg, setErrorMsg] = useState(true);

  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    editDriver(values);
    setLoading(true);
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik({
    initialValues: {
      firstName: data.firstName,
      lastName: data.lastName,
      gender: data.gender,
      driverScince: data.driverScince,
      phoneNumber: data.phoneNumber,
      address: data.address,
      driverImage: data.driverImage,
      documents: data.documents,
      status: data.status,
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const DatePickerField = ({ name, value, onChange }) => {
    return (
      <DatePicker
        selected={(value && new Date(value)) || null}
        onChange={(val) => {
          onChange(name, val);
        }}
      />
    );
  };
  const notifySuccess = () =>
    toast.info("Driver info Updated.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const editDriver = async (e, i) => {
    try {
      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
      }
      bodyFormData.append("id", id);

      const response = await axios
        .post("/driver/" + id, bodyFormData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
            // Other headers if required
          },
        })
        .then((res) => {
          // history("/drivers");
          hideModal();
          notifySuccess();
          getDrivers();
        })
        .catch((err) => {
          setLoading(false);
          setErrorMsg(err.response.data.msg);
          notifyError();
        });
    } catch (error) {
      notifyError();
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      encType="multipart/form-data"
    >
      <Modal
      style={{marginTop: "60px"}}
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        contentClassName="custom-modal-style"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Driver </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && (
            <div
              style={{
                position: "absolute",
                zIndex: "1000",
                top: 50 + "%",
                left: 50 + "%",
              }}
            >
              <Loader />
            </div>
          )}
          <div class="row">
            <div class="col-md-6">
              <div class="card card-primary">
                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">{values.firstName}</label>
                    <input
                      type="text"
                      name="firstName"
                      value={values.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.firstName && touched.firstName
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.firstName && touched.firstName && (
                      <p className="error">{errors.firstName}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      value={values.lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.lastName && touched.lastName
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.lastName && touched.lastName && (
                      <p className="error">{errors.lastName}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Phone Number</label>
                    <input
                      type="text"
                      id="inputName"
                      name="phoneNumber"
                      value={values.phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.phoneNumber && touched.phoneNumber
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.phoneNumber && touched.phoneNumber && (
                      <p className="error">{errors.phoneNumber}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label for="inputStatus">Gender</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="gender"
                      value={values.gender}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.gender && touched.gender
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Gender</option>
                      <option selected={values.gender == "Male"} value={"Male"}>
                        Male
                      </option>
                      <option
                        value={"Female"}
                        selected={values.gender == "Female"}
                      >
                        Female
                      </option>
                    </select>
                    {errors.gender && touched.gender && (
                      <p className="error">{errors.gender}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="inputName">Address</label>
                    <input
                      type="text"
                      id="inputName"
                      name="address"
                      value={values.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.address && touched.address
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.address && touched.address && (
                      <p className="error">{errors.address}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card card-success">
                <div className="card-body">
                  <div class="form-group">
                    <label for="inputEstimatedBudget">Driver Scince Year</label>

                    <DatePickerField
                      name="driverScince"
                      id="inputEstimatedBudget"
                      class="form-control"
                      value={values.driverScince}
                      onChange={setFieldValue}
                      className={
                        errors.driverScince && touched.driverScince
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />

                    {errors.driverScince && touched.driverScince && (
                      <p className="error">{errors.driverScince}</p>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="exampleInputFile">Driver Image </label>
                    <Collapsible
                      trigger={<i className="fas fa-eye success"> View</i>}
                    >
                      <img
                        className=" img-fluid "
                        src={
                          process.env.REACT_APP_BASE_URL + values.driverImage
                        }
                        height="300px"
                        width="300px"
                        alt="driver picture"
                      />
                    </Collapsible>

                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFile"
                          name="driverImage"
                          accept="image/*"
                          onChange={(e) =>
                            setFieldValue(
                              "driverImage",
                              e.currentTarget.files[0]
                            )
                          }
                          className={
                            errors.driverImage && touched.driverImage
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.driverImage && touched.driverImage && (
                      <p className="error">{errors.driverImage}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile">Legal Documents</label>
                    <Collapsible
                      trigger={<i className="fas fa-eye success"> View</i>}
                    >
                      <img
                        className=" img-fluid "
                        src={process.env.REACT_APP_BASE_URL + values.documents}
                        height="300px"
                        width="300px"
                        alt="vehicle picture"
                      />
                    </Collapsible>

                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFileq"
                          name="documents"
                          onChange={(event) => {
                            setFieldValue(
                              "documents",
                              event.currentTarget.files[0]
                            );
                          }}
                          onBlur={handleBlur}
                          className={
                            errors.documents && touched.documents
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                      </div>
                    </div>
                    {errors.documents && touched.documents && (
                      <p className="error">{errors.documents}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label for="inputStatus">Status</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.status && touched.status
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Status</option>
                      <option
                        selected={values.status == "Active"}
                        value={"Active"}
                      >
                        Active
                      </option>
                      <option
                        value={"Inactive"}
                        selected={values.status == "Inactive"}
                      >
                        Inactive
                      </option>
                    </select>
                    {errors.status && touched.status && (
                      <p className="error">{errors.status}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {errorMsg && (
            <div>
              <h5 className="error">{errorMsg}</h5>
            </div>
          )}
          <button className="btn btn-error" onClick={hideModal}>
            Cancel
          </button>

          <button
            disabled={isSubmitting}
            onClick={submitForm}
            className="btn btn-success"
            type="submit"
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default Edit;
